import { useState, useContext } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Ctx from '../ContextForm';
import ArgonBox from 'component/Argon/ArgonBox';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { object, string } from 'yup';
import InputAddress from 'page/sign-up/components/InputAddress';
import InputDistrict from 'page/sign-up/components/InputDistrict';
import InputArea from 'page/sign-up/components/InputArea';
import InputProvince from 'page/sign-up/components/InputProvince';
import InputZipcode from 'page/sign-up/components/InputZipcode';
import { useCreateUserAddress } from 'api/user/useUserAddress';

export const addressSchema = object({
  address1: string().min(2).required(),
  district: string().min(2).required(),
  area: string().min(2),
  province: string().min(3),
  zipcode: string(),
}).required();

export default function FormDialog() {
  const { open, setOpen, refreshAddress } = useContext(Ctx);
  const { mutateAsync: postAddress } = useCreateUserAddress();

  const form = useForm({
    mode: 'onBlur',
    resolver: yupResolver(addressSchema),
    defaultValues: {
      address1: '',
      district: '',
      area: '',
      province: '',
      zipcode: '',
    },
  });
  const [area, setArea] = useState('');
  const [province, setProvince] = useState('');
  const [zipcode, setZipcode] = useState('');

  const {
    handleSubmit,
    setValue,
    formState: { errors },
  } = form;

  const handleClose = () => {
    setOpen(false);
  };

  const onCommit = (value) => {
    console.log(value);
    if (value) {
      const { amphoe, province, zipcode } = value;
      setArea(amphoe);
      setProvince(province);
      setZipcode(zipcode);
      setValue('area', amphoe);
      setValue('province', province);
      setValue('zipcode', zipcode);
    }
  };

  function onSubmit(data) {
    // fix zipcode undefine WTF!
    const address = { ...data, area, province, zipcode };
    console.log(address);
    postAddress(address).then((resData) => {
      console.log(resData);
      if (resData?.id) {
        refreshAddress();
        setOpen(false);
      }
    });
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth={'xl'}>
      <DialogTitle>เพิ่มที่อยู่</DialogTitle>
      <DialogContent>
        <ArgonBox component="form" role="form">
          <ArgonBox mb={2}>
            <InputAddress form={form} />
            <ArgonBox mt={4}>
              <InputDistrict form={form} onCommit={onCommit} />
            </ArgonBox>
            <InputArea form={form} />
            <InputProvince form={form} />
            <InputZipcode form={form} />
          </ArgonBox>
        </ArgonBox>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>ยกเลิก</Button>
        <Button onClick={handleSubmit(onSubmit)}>บันทึก</Button>
      </DialogActions>
    </Dialog>
  );
}
